import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from "@auth0/auth0-react";
import 'bootstrap';
import '@fortawesome/fontawesome-free';
import UserProvider from './hooks/userHook';
import App from './App';
import { currentEnvironment } from './utils/environment';
import { EnvironmentOptions } from './utils/constants';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './style/main.scss';

const root = ReactDOMClient.createRoot(document.getElementById('schedule-app') as HTMLElement);

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain="fullimpact.us.auth0.com"
      clientId="T2xehrB6gD8a6Ot7mFqQtiwutbOVn47i"
      authorizationParams={{
        redirect_uri: `${window.location.origin}/schedule`,
        audience: "https://fullimpact.us.auth0.com/api/v2/",
        // scope: "read:current_user update:current_user_metadata"
      }}
      cacheLocation={'localstorage'}
      useRefreshTokens={true}
    >
      <UserProvider>
        <BrowserRouter basename="/schedule">
          <App />
        </BrowserRouter>
      </UserProvider>
    </Auth0Provider>
  </React.StrictMode>
);

if (currentEnvironment() === EnvironmentOptions.Development) {
  document.title = `!!TEST ONLY!! - ${document.title}`;
} else {
  // console = { // eslint-disable-line no-native-reassign, no-global-assign
  //   ...console,
  //   log: () => null
  // }; // <-- Uncomment when done debugging!
}

console.log('ENVIRONMENT: ', currentEnvironment());

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();